import { isCarsTrucks } from '@kijiji/category'
import { type SearchQuery } from '@kijiji/generated/graphql-types'

import { RemoteToggles } from '@/lib/firebase/config/toggles'
import { useToggle } from '@/lib/firebase/hooks'

export const useAutoBrp = ({
  categoryId,
  keywords,
  filters,
}: {
  categoryId: number
  keywords: SearchQuery['keywords'] | undefined
  filters: SearchQuery['filters'] | undefined
}) => {
  const enableTopBrp = useToggle(RemoteToggles.VERTICAL_AUTOS_BRP_TOGGLE.key)

  const isValidCategory = isCarsTrucks(categoryId)
  const isBRP = !(keywords ?? '')?.length
  const hasSelectedFilters = !!(filters ?? []).length

  const isAutoBrp = !(!enableTopBrp?.enabled || !isValidCategory || !isBRP || !!hasSelectedFilters)

  return { isAutoBrp }
}
